import axios from 'axios'
import { User, UserFormValues, EditUserRole } from '../models/User'
import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'

interface UserResponse extends HttpResponse {
  data: User
}

interface UserListResponse extends HttpResponse {
  data: User[]
}

interface ModeratorListResponse extends HttpResponse {
  data: string[]
}

const Account = {
  current: () => requests.get<UserResponse>('/account'),
  login: (user: UserFormValues) => requests.post<UserResponse>('/account/login', user),
  register: (user: UserFormValues) => requests.post<UserResponse>('/account/register', user),
  changeLanguage: (data: { language: string }) => requests.put('/account/language', data),
  loginGoogle: (accessToken: string) =>
    requests.post<UserResponse>(`/account/googleLogin?accessToken=${accessToken}`, {}),
  fbLogin: (accessToken: string) =>
    requests.post<UserResponse>(`/account/fbLogin?accessToken=${accessToken}`, {}),
  verifyEmail: (token: string, id: string) =>
    requests.post<HttpResponse>(`/account/verifyEmail?token=${token}&id=${id}`, {}),
  resendEmailConfirm: (id: string) =>
    requests.get<HttpResponse>(`/account/resendEmailConfirmationLink?id=${id}`),
  list: () => requests.get<UserListResponse>('/account/allUsers'),
  edit: (user: User) => {
    const userSend: EditUserRole = {
      email: user.email,
      userRoles: user.userRoles.join(','),
    }
    axios.put<HttpResponse>(`/account/${user.email}`, userSend)
  },
  delete: (email: string) => axios.delete<HttpResponse>(`/account/${email}`),
  getModerators: () => requests.get<ModeratorListResponse>('/account/moderator'),
}

export default Account
